import React from 'react';
import { Polyline } from 'react-leaflet';

import type { CorridorDisplay } from '@/features/map-corridors';

interface CorridorLayerProps {
  corridors: CorridorDisplay[];
  showCorridors: boolean;
}

export const CorridorLayer = React.memo(({ corridors, showCorridors }: CorridorLayerProps) => {
  if (!showCorridors || corridors.length === 0) return null;

  return (
    <>
      {corridors.map((corridor) => (
        <Polyline
          key={corridor.id}
          positions={[
            [corridor.from.lat, corridor.from.lng],
            [corridor.to.lat, corridor.to.lng]
          ]}
          pathOptions={{
            color: corridor.color,
            weight: corridor.lineWidth || 2,
            opacity: 0.7
          }}
        />
      ))}
    </>
  );
});
